module.exports = __webpack_public_path__ + "static/media/linhas_animadas.48922c37.mp4";